import Modal from '@deprecated-ui/common/Modal';
import styled from 'styled-components';

const ModalConfirm = styled(Modal)`
  .ant-modal-header {
    border-radius: 3px 3px 0 0;
  }
  .ant-modal-content {
    border-radius: 3px !important;
  }
  .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
  }
  button {
    font-weight: bold;
  }
`;

const PostLimitContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 1.5px 0;
  .text-container {
    margin: 0 32px;
    width: 336px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export { ModalConfirm, PostLimitContainer };
